import styled from "styled-components";
import { H2 } from "../../../common";

export const FilterCondition = styled(H2)`
  font-size: ${({ theme }) => theme.fontSize.xl4};
  font-family: ${({ theme }) => theme.font.monospace};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;
